import { persistor } from 'store';

import {
  getStorageStartStop,
  getStorageEndStop,
  getStorageLastPath,
  setStorageStartStop,
  setStorageEndStop,
  setStorageLastPath,
} from './ticketSales';

import {
  getTestOnly,
  setStorageTestOnly,
  getDaysLimitToReportDurable,
  setStorageDaysLimitToReportDurable,
} from './localConfig';

export const clearStorageSafely = () => {
    const storageStartStop = getStorageStartStop();
    const storageEndStop = getStorageEndStop();
    const storageLastPath = getStorageLastPath();
    const storageTestOnly = getTestOnly();
    const storageDaysLimitToReportDurable = getDaysLimitToReportDurable();

    persistor.purge();
    localStorage.clear();
    sessionStorage.clear();

    setStorageStartStop(storageStartStop);
    setStorageEndStop(storageEndStop);
    setStorageLastPath(storageLastPath);
    setStorageTestOnly(storageTestOnly);
    setStorageDaysLimitToReportDurable(storageDaysLimitToReportDurable);
};
